import { BrowserRouter, Route, Switch } from 'react-router-dom';

import AppContainer from 'components/layout/AppContainer';
import MissingLicensePage from 'components/pages/missing-license-page';
import LetterNumberFormationsRoute from './letter-number-formation-routes';

import { checkAccessToResource } from '../api/pli-service';
import Config from 'config';

function Routes({ useSSO }) {
  function handleForbidden(history) {
    return function () {
      history.push('/no-access');
    };
  }

  function handleAuthFail() {
    window.location = Config.HITT_URL as Location;
  }

  function handleAuth(params) {
    return function () {
      return checkAccessToResource({
        characterType: params.characterType,
        characterCase: params.characterCase,
        character: params.character,
      });
    };
  }

  return (
    <BrowserRouter>
      <Switch>
        <Route path='/no-access' component={MissingLicensePage} />
        <Route
          path='/'
          render={() => (
            <AppContainer>
              <LetterNumberFormationsRoute
                useSSO={useSSO === 'true'}
                onAuth={handleAuth}
                onForbidden={handleForbidden}
                onAuthFailure={handleAuthFail}
              />
            </AppContainer>
          )}
        />
      </Switch>
    </BrowserRouter>
  );
}

export default Routes;
